<template>
  <div class="organization">
    <div class="company-container">
      <div class="search">
        <svg
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2864"
          width="16"
          height="16"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M222.6944 222.7968A323.1488 323.1488 0 0 0 133.6832 512c19.2512-87.3728 64.512-172.7488 135.0144-243.3024C339.2512 198.1184 424.6272 152.8832 512 133.632c-101.632-19.1488-210.688 10.5216-289.3056 89.1648z"
            fill="#999999"
            p-id="2865"
          />
          <path
            d="M989.44 822.1184l-121.7024-121.7024a118.016 118.016 0 0 0-92.8-34.1248c114.4576-165.5552 97.92-394.3936-49.4848-541.824-165.9392-165.9904-435.0464-165.9904-601.0368 0-165.9392 165.9904-165.9392 435.1232 0 601.1136 147.4048 147.4304 376.064 163.84 541.7216 49.3824-2.56 33.28 8.8576 67.5328 34.1248 92.8l121.7024 121.728c46.08 45.9776 121.3696 45.9776 167.3472 0 46.208-45.9776 46.208-121.2928 0.128-167.3728zM676.096 676.096c-138.6752 138.6752-363.392 138.6752-502.016 0-138.6752-138.6752-138.6752-363.4432 0-502.1184 138.624-138.6752 363.3408-138.6752 502.016 0 138.6496 138.5728 138.6496 363.4432 0 502.1184z"
            fill="#999999"
            p-id="2866"
          />
        </svg>
        <el-input class="white" placeholder="搜索" v-model="filterText"></el-input>
      </div>
      <div class="company">
        <el-tree
          ref="tree"
          node-key="id"
          :filter-node-method="filterNode"
          :data="companyList"
          :props="defaultProps"
          :highlight-current="true"
          :default-expanded-keys="[departmentId]"
          :current-node-key="departmentId"
          :expand-on-click-node="false"
          :default-expand-all="true"
          @node-click="handleNodeClick"
        ></el-tree>
      </div>
    </div>
    <div class="frame-content">
      <div class="frame-head" v-show="type">
        <div class="frame-head-left">
          <p class="title">
            <span>{{ title }}</span>
          </p>
        </div>
        <el-button class="btn-blue" v-show="type === 2" @click="openAssignPeople">待分配</el-button>
      </div>
      <div class="department" v-show="type === 1">
        <div class="title-item">
          <img src="../../../../assets/images/employee/department.png" alt />
          <p class="title-text">下级部门</p>
          <el-button class="btn-white" @click="showAddDepartmentDialog()">添加子部门</el-button>
        </div>
        <ul class="department-list">
          <li class="department-item">
            <p class="department-title">部门名称</p>
            <p class="department-title">仓库</p>
            <p class="department-title">考勤</p>
            <p class="department-title">分摊规则</p>
            <p class="department-title">操作</p>
          </li>
          <li
            class="department-item"
            v-for="(value, index) in companyList[0].children"
            :key="index"
          >
            <p class="department-item-content">{{ value.label }}</p>
            <p class="department-item-content">{{ value.warehouseName }}</p>
            <p class="department-item-content">{{ value.isAttendanceText }}</p>
            <p class="department-item-content">{{ value.shareTypeText }}</p>
            <p class="department-item-content">
              <el-button class="btn-text" type="text" @click="delDepartment(value.id)">删除</el-button>
              <el-button class="btn-text" type="text" @click="updateDepartment(value)">编辑</el-button>
              <el-button
                v-if="value.shareType!==1"
                class="btn-text"
                type="text"
                @click="toRuleSetting(value.id)"
              >规则设置</el-button>
            </p>
          </li>
        </ul>
      </div>
      <div class="staff" v-show="type === 2">
        <div class="title-item">
          <img src="../../../../assets/images/employee/staff.png" alt />
          <p class="title-text">部门人员</p>
        </div>
        <ul class="staff-list">
          <li class="staff-item">
            <p class="staff-title">姓名</p>
            <p class="staff-title">手机号</p>
            <p class="staff-title">是否启用</p>
            <p class="staff-title">操作</p>
          </li>
          <li class="staff-item" v-for="(value, index) in userList" :key="index">
            <p class="staff-item-content">{{ value.name }}</p>
            <p class="staff-item-content">{{ value.phone }}</p>
            <p class="staff-item-content">
              <el-switch
                v-model="value.status"
                @change="updateEmployeeStatus(value.id, value.status)"
                active-color="#2E68EA"
                inactive-color="#D5D5D6"
              ></el-switch>
            </p>
            <p class="staff-item-content">
              <el-button
                :disabled="!value.status"
                :class="value.status ? 'btn-text' : 'btn-text gray'"
                type="text"
                @click="toEmployeeSetting(value.id,value.name)"
              >权限设置</el-button>
              <el-button
                :disabled="!value.status"
                :class="value.status ? 'btn-text' : 'btn-text gray'"
                type="text"
                @click="openEmployeeDialog(value.id, value)"
              >编辑</el-button>
              <el-button class="btn-text" type="text" @click="delEmployee(value.id)">删除</el-button>
            </p>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog
      :title="departmentDialogTitle"
      top="25vh"
      :visible.sync="addDepartmentDialog"
      width="420px"
    >
      <div class="border"></div>
      <el-form
        ref="departmentForm"
        :rules="departmentFormRules"
        :model="departmentForm"
        label-width="100px"
      >
        <el-form-item label="部门名称：" prop="department">
          <el-input class="white" v-model="departmentForm.department" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="仓库：" prop="warehouseId">
          <el-select class="white" v-model="departmentForm.warehouseId" placeholder="请选择仓库">
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考勤：" prop="isAttendance">
          <el-select class="white" v-model="departmentForm.isAttendance" placeholder="请选择考勤">
            <el-option
              v-for="item in attendanceList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分摊规则：" prop="shareType">
          <el-select class="white" v-model="departmentForm.shareType" placeholder="请选择分摊规则">
            <el-option
              v-for="item in shareTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeAddDepartmentDialog('departmentForm')">取消</el-button>
        <el-button class="btn-blue" @click="submitAddDepartment('departmentForm')">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="待分配人员" top="15vh" :visible.sync="assignPeopleDialog" width="1100px">
      <div class="border"></div>
      <div class="table">
        <div class="table-left">
          <div class="search-table">
            <el-input class="gray" v-model="userName" placeholder="请输入人员姓名"></el-input>
            <el-button class="btn-blue" @click="searchAssignPeople">搜索</el-button>
          </div>
          <el-table :data="assignPeople" style="width: 100%" height="250">
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column label>
              <template slot-scope="scope">
                <el-button class="btn-text" type="text" @click="choicePeople(scope.row)">选择</el-button>
                <!-- <el-button class="btn-text" type="text" @click="delPeople(scope.row.id)">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-right">
          <!-- <el-select class="gray" v-model="department" placeholder="请选择">
            <el-option
              v-for="item in departmentList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>-->
          <el-table :data="selectPeople" style="width: 100%" height="250">
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column label>
              <template slot-scope="scope">
                <el-button class="btn-text" type="text" @click="removePeople(scope.$index)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeAssignPeople">取消</el-button>
        <el-button class="btn-blue" @click="definePeople">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑" top="35vh" :visible.sync="employeeDialog" width="420px">
      <div class="border"></div>
      <p class="error">
        <span v-if="errorMessage">{{ errorMessage }}</span>
      </p>
      <el-form
        ref="employeeForm"
        :rules="employeeFormRules"
        :model="employeeForm"
        label-width="80px"
      >
        <el-form-item label="员工姓名：" prop="name">
          <el-input v-model="employeeForm.name" class="white"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="employeeForm.phone" class="white"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeEmployeeDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveEmployee('employeeForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Employee from "models/employee";
import Expenses from "models/expenses";
const employee = new Employee();
const expenses = new Expenses();
export default {
  data() {
    return {
      title: "宁波中外运物流有限公司",
      updateTitle: false,
      filterText: "",
      companyList: [
        {
          id: 0,
          label: "宁波中外运物流有限公司",
          type: 1,
          children: []
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      },
      departmentId: 0,
      type: 1,
      userList: [],
      //添加部门
      addDepartmentDialog: false,
      departmentDialogTitle: "添加子部门",
      departmentForm: {
        id: "",
        department: "",
        warehouseId: "",
        isAttendance: "",
        shareType: ""
      },
      departmentFormRules: {
        department: [
          { required: true, message: "请输入部门名称", trigger: "blur" }
        ],
        warehouseId: [
          { required: true, message: "请选择仓库", trigger: "change" }
        ],
        isAttendance: [
          { required: true, message: "请选择考勤", trigger: "change" }
        ],
        shareType: [
          { required: true, message: "请选择分摊规则", trigger: "change" }
        ]
      },
      warehouseList: [],
      attendanceList: [
        {
          id: 1,
          name: "是"
        },
        {
          id: 0,
          name: "否"
        }
      ],
      shareTypeList: [
        {
          id: 1,
          name: "订单比例"
        },
        {
          id: 2,
          name: "订单复杂度"
        }
      ],
      //人员弹窗数据
      assignPeopleDialog: false,
      userName: "",
      userNameSearch: "",
      assignPeople: [],
      selectPeople: [],
      department: "",
      departmentList: [],
      //编辑员工
      employeeDialog: false,
      employeeForm: {
        id: "",
        name: "",
        phone: ""
      },
      employeeFormRules: {
        name: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }]
      },
      errorMessage: ""
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.getCompanyList();
    this.getWarehouse();
    this.getAssignPeople();
  },
  methods: {
    //获取部门数据
    getCompanyList() {
      employee.getDeptList().then(res => {
        let companyList = [
          {
            id: 0,
            label: "宁波中外运物流有限公司",
            type: 1,
            children: []
          }
        ];
        if (res.success) {
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.label = value.name;
            obj.type = 2;
            obj.warehouseId = value.warehouseId;
            obj.warehouseName = value.warehouseName;
            obj.isAttendanceText = value.isAttendance === 0 ? "否" : "是";
            obj.isAttendance = value.isAttendance;
            obj.shareTypeText =
              value.shareType === 1 ? "订单比例 " : "订单复杂度";
            obj.shareType = value.shareType;
            companyList[0].children.push(obj);
          });
          this.companyList = companyList;
        }
      });
    },
    //获取部门员工
    getUserList() {
      let deptId = this.departmentId;
      employee.getEmployeeList(deptId).then(res => {
        if (res.success) {
          let userList = [];
          res.result.map(value => {
            let obj = {};
            obj.name = value.name;
            obj.id = value.id;
            obj.phone = value.phoneNumber;
            obj.status = value.status === 1 ? true : false;
            userList.push(obj);
          });
          this.userList = userList;
        }
      });
    },
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //点击部门
    handleNodeClick(data) {
      console.log(data);
      this.title = data.label;
      this.type = data.type;
      this.departmentId = data.id;
      if (data.type === 2) {
        this.getUserList();
      }
    },
    //显示部门弹窗
    showAddDepartmentDialog() {
      this.departmentDialogTitle = "添加子部门";
      this.addDepartmentDialog = true;
      this.departmentForm.id = "";
      this.$nextTick(() => {
        if (this.$refs.departmentForm) {
          this.$refs.departmentForm.resetFields();
        }
      });

      // this.departmentForm.department = "";
      // this.departmentForm.warehouseId = "";
      // this.departmentForm.isAttendance = "";
      // this.departmentForm.shareType = "";
    },
    //关闭部门弹窗
    closeAddDepartmentDialog(departmentForm = "departmentForm") {
      this.departmentForm.id = "";
      this.$refs[departmentForm].resetFields();
      this.addDepartmentDialog = false;
    },
    //添加部门
    submitAddDepartment(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.name = this.departmentForm.department;
          data.warehouseId = this.departmentForm.warehouseId;
          data.isAttendance = this.departmentForm.isAttendance;
          data.shareType = this.departmentForm.shareType;
          if (this.departmentForm.id) {
            data.id = this.departmentForm.id;
            employee.postUpdateDept(data).then(res => {
              if (res.success) {
                this.getCompanyList();
                this.closeAddDepartmentDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            employee.postAddDept(data).then(res => {
              if (res.success) {
                this.getCompanyList();
                this.closeAddDepartmentDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除部门
    delDepartment(id) {
      this.$confirm("是否确定删除该部门?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = {
          id
        };
        employee.postDelDept(data).then(res => {
          if (res.success) {
            this.getCompanyList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    //编辑部门
    updateDepartment(value) {
      this.departmentDialogTitle = "编辑子部门";
      this.departmentForm.id = value.id;
      this.departmentForm.department = value.label;
      this.departmentForm.warehouseId = value.warehouseId;
      this.departmentForm.isAttendance = value.isAttendance;
      this.departmentForm.shareType = value.shareType;
      this.addDepartmentDialog = true;
    },
    //规则设置
    toRuleSetting(id) {
      this.$router.push({
        path: `/attendance/employee/employee-organization/rule-setting?id=${id}`
      });
    },
    //修改员工状态
    updateEmployeeStatus(id, status) {
      let data = {};
      data.id = id;
      data.status = status ? 1 : 0;
      employee.postUpdateEmployeeStatus(data).then(res => {
        if (res.success) {
          console.log("成功");
        }
      });
    },
    //关闭编辑员工
    closeEmployeeDialog() {
      this.employeeDialog = false;
    },
    //显示编辑员工
    openEmployeeDialog(id, row) {
      this.employeeDialog = true;
      if (id) {
        this.employeeForm.id = id;
        this.employeeForm.name = row.name;
        this.employeeForm.phone = row.phone;
      }
    },
    //保存编辑员工
    saveEmployee(formName) {
      this.errorMessage = "";
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.employeeForm.id) {
            let data = {};
            data.id = this.employeeForm.id;
            data.name = this.employeeForm.name;
            data.phoneNumber = this.employeeForm.phone;
            employee.postUpdateEmployee(data).then(res => {
              if (res.success) {
                this.$message.success("编辑成功");
                this.getUserList();
                this.closeEmployeeDialog();
              } else {
                this.errorMessage = res.message;
              }
            });
          } else {
            let data = {};
            data.name = this.employeeForm.name;
            data.phoneNumber = this.employeeForm.phone;
            employee.postAddEmployee(data).then(res => {
              if (res.success) {
                this.$message.success("新增成功");
                this.employeeList();
                this.closeEmployeeDialog();
              } else {
                this.errorMessage = res.message;
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除员工
    delEmployee(id) {
      this.$confirm("是否删除该员工?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = { id };
          employee.postDelEmployee(data).then(res => {
            if (res.success) {
              this.getUserList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    //前往规则设定
    toEmployeeSetting(id, name) {
      this.$router.push(
        `/attendance/employee/employee-organization/employee-setting?id=${id}&name=${name}`
      );
    },
    //待分配人员
    //显示待分配人员
    openAssignPeople() {
      this.assignPeopleDialog = true;
    },
    closeAssignPeople() {
      this.assignPeopleDialog = false;
    },
    //获取待分配人员列表
    getAssignPeople() {
      let name = this.userNameSearch;
      employee.getEmployeeFree(name).then(res => {
        if (res.success) {
          let assignPeople = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.phone = value.phoneNumber;
            assignPeople.push(obj);
          });
          this.assignPeople = assignPeople;
        }
      });
    },
    searchAssignPeople() {
      this.userNameSearch = this.userName;
      this.getAssignPeople();
    },
    choicePeople(row) {
      let stop = false;
      this.selectPeople.map(value => {
        if (value.id === row.id) {
          stop = true;
        }
      });
      if (!stop) {
        this.selectPeople.push(row);
      }
    },
    removePeople(index) {
      this.selectPeople.splice(index, 1);
    },
    definePeople() {
      let data = {};
      data.employeeIdList = [];
      data.deptId = this.departmentId;
      this.selectPeople.map(value => {
        data.employeeIdList.push(value.id);
      });
      employee.postAddFreeUser(data).then(res => {
        if (res.success) {
          this.getAssignPeople();
          this.selectPeople = [];
          this.closeAssignPeople();
          this.getUserList();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.organization {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  .company-container {
    overflow: auto;
    width: 240px;
    background: rgba(231, 232, 235, 1);
    border-radius: 8px 0px 0px 8px;
    box-sizing: border-box;
    padding: 20px 12px;
    .search {
      position: relative;
      margin-bottom: 10px;
      .icon {
        position: absolute;
        top: 8px;
        left: 7px;
        z-index: 100;
        cursor: pointer;
      }
    }
    .company {
      .el-tree {
        background: #e7e8eb;
      }
    }
  }
  .frame-content {
    flex: 1;
    overflow: auto;
    padding: 16px;
    .frame-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      margin-bottom: 20px;
      .frame-head-left {
        display: flex;
        align-items: center;
      }
      .btn-white {
        margin-left: 16px;
        border-radius: 14px;
        height: 28px;
      }
      .btn-blue {
        margin-left: 16px;
        border-radius: 14px;
        height: 28px;
      }
    }
    .title-item {
      display: flex;
      align-items: center;
      border-bottom: 20px solid #eceff4;
      padding-bottom: 10px;
      font-size: 20px;
      .title-text {
        margin-left: 16px;
      }
      .btn-white {
        height: 28px;
        border-radius: 14px;
        margin-left: 16px;
      }
    }
    .department {
      margin-bottom: 10px;
      .department-item {
        height: 40px;
        padding: 0 20px;
        border-bottom: 1px solid #e5e5e5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #777777;
        .department-title {
          width: 200px;
          font-weight: bold;
        }
        .department-item-content {
          width: 200px;
        }
      }
    }
    .staff {
      margin-bottom: 10px;
      .staff-item {
        height: 40px;
        padding: 0 20px;
        border-bottom: 1px solid #e5e5e5;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #777777;
        justify-content: space-between;
        .staff-title {
          width: 200px;
          font-weight: bold;
        }
        .staff-item-content {
          width: 200px;
        }
        .gray {
          color: #aaa;
        }
      }
    }
  }
  .el-dialog {
    .el-form {
      padding-right: 20px;
      .el-form-item {
        .el-select {
          width: 100%;
        }
      }
    }
    .table {
      display: flex;
      .table-left {
        flex: 1;
        padding-right: 16px;
        border-right: 1px solid #e2e2e2;
        box-sizing: border-box;
        overflow: hidden;
        .search-table {
          display: flex;
          .gray {
            width: 240px;
            margin-right: 16px;
            margin-bottom: 16px;
          }
        }
      }
      .table-right {
        flex: 1;
        padding-left: 16px;
        padding-top: 48px;
        box-sizing: border-box;
        overflow: hidden;
        .gray {
          margin-bottom: 16px;
        }
      }
    }
    .dialog-footer {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px solid #eee;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
<style lang="scss">
.organization {
  .search {
    .el-input.white .el-input__inner {
      padding-left: 30px;
    }
  }
  .company {
    .el-tree {
      background: #e7e8eb;
      .el-tree-node__content {
        height: 36px;
      }
    }
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background-color: #4065e0;
      color: #fff;
    }
  }
  .title {
    .el-input.gray {
      width: 80px;
      .el-input__inner {
        height: 28px;
      }
    }
  }
}
</style>
